function Carousel({ root, gap = 0 }) {
  this.root = root;
  this.currentIndex = 0;
  this.gap = gap;
  this.slidesWidth = 0;
  this.singleSlideWidth = 0;
  this.slidesCount = 0;
  this.slideDuration = 0.25;
  // Gsap Timeline
  this.tl;

  this.init();
  this.registerDrag();
  this.animateBackSlides();
  this.animateFrontSlides();
  this.registerButtons();
  this.registerSlider();
  this.tl.pause();

  const instance = this;

  window.addEventListener("resize", function () {
    instance.tl.clear();

    instance.init();
    instance.registerDrag();
    instance.animateBackSlides();
    instance.animateFrontSlides();
    instance.registerButtons();
    instance.registerSlider();
    instance.tl.pause();
  });
}

Carousel.prototype.init = function () {
  const backSlidesWrapper = this.root.querySelector(".back-slides-wrapper");
  const backSlides = backSlidesWrapper.querySelectorAll(".back-slide");
  const slidesCount = backSlides.length;

  const frontSlidesWrapper = this.root.querySelector(".front-slides-wrapper");
  if (frontSlidesWrapper) {
    const frontSlides = frontSlidesWrapper.querySelectorAll(".front-slide");
    Array.from(frontSlides)[0].style.display = "flex";
  }

  this.slidesCount = slidesCount;

  this.tl = gsap.timeline({
    repeat: 0,
  });

  backSlidesWrapper.style.width = `${slidesCount * 100}%`;
  this.slidesWidth = getWidth(backSlidesWrapper);
  this.singleSlideWidth = this.slidesWidth / this.slidesCount;
  const instance = this;

  window.addEventListener("resize", function () {
    instance.slidesWidth = getWidth(backSlidesWrapper);
    instance.singleSlideWidth = instance.slidesWidth / instance.slidesCount;
  });
};

Carousel.prototype.animateBackSlides = function () {
  const backSlidesWrapper = this.root.querySelector(".back-slides-wrapper");
  const viewport = this.root.querySelector(".viewport");
  this.tl.to(backSlidesWrapper, {
    x: -parseFloat(this.slidesWidth - this.singleSlideWidth),
    duration: (this.slidesCount - 1) * this.slideDuration,
    ease: "linear",
  });

  const backSlides = Array.from(
    backSlidesWrapper.querySelectorAll(".back-slide")
  );
  backSlides.slice(1).forEach((slide) => {
    slide.style.height = `${getHeight(viewport) * 0.85}px`;
  });

  this.tl.to(
    backSlides[0],
    {
      height: `${getHeight(viewport) * 0.85}px`,
      x: `-${this.gap}px`,
      duration: this.slideDuration,
      ease: "linear",
    },
    0
  );
  this.tl.fromTo(
    backSlides[backSlides.length - 1],
    {
      x: `${this.gap}px`,
    },
    {
      height: `${getHeight(viewport)}px`,
      x: 0,
      duration: this.slideDuration,
      ease: "linear",
    },
    this.slideDuration * (backSlides.length - 2)
  );
  backSlides.slice(1, -1).forEach((slide, index) => {
    this.tl.fromTo(
      slide,
      {
        x: `${this.gap}px`,
      },
      {
        height: `${getHeight(viewport)}px`,
        x: 0,
        duration: this.slideDuration,
        ease: "linear",
      },
      this.slideDuration * index
    );
    this.tl.to(
      slide,
      {
        height: `${getHeight(viewport) * 0.85}px`,
        x: `-${this.gap}px`,
        opacity: 0.3,
        duration: this.slideDuration,
        ease: "linear",
      },
      this.slideDuration * (index + 1)
    );
  });
};

Carousel.prototype.animateFrontSlides = function () {
  const frontSlidesWrapper = this.root.querySelector(".front-slides-wrapper");

  if (frontSlidesWrapper) {
    const frontSlides = Array.from(
      frontSlidesWrapper.querySelectorAll(".front-slide")
    );

    // First Slide
    this.tl.to(
      frontSlides[0],
      {
        opacity: 0,
        display: "none",
        duration: this.slideDuration,
        ease: "linear",
      },
      0
    );
    this.tl.to(
      frontSlides[0].querySelector(".slide-count"),
      {
        y: "-100%",
        duration: this.slideDuration,
        ease: "linear",
      },
      0
    );
    this.tl.to(
      frontSlides[0].querySelector(".slide-title"),
      {
        y: "-100%",
        duration: this.slideDuration,
        ease: "linear",
      },
      0
    );

    const lastIndex = frontSlides.length - 1;

    // Last Slide
    this.tl.fromTo(
      frontSlides[lastIndex],
      {
        opacity: 0,
        display: "none",
      },
      {
        opacity: 1,
        display: "flex",
        duration: this.slideDuration,
        ease: "linear",
      },
      this.slideDuration * (lastIndex - 1)
    );
    this.tl.fromTo(
      frontSlides[lastIndex].querySelector(".slide-count"),
      {
        y: "100%",
      },
      {
        y: 0,
        duration: this.slideDuration,
        ease: "linear",
      },
      this.slideDuration * (lastIndex - 1)
    );
    this.tl.fromTo(
      frontSlides[lastIndex].querySelector(".slide-title"),
      {
        y: "100%",
      },
      {
        y: 0,
        duration: this.slideDuration,
        ease: "linear",
      },
      this.slideDuration * (lastIndex - 1)
    );

    frontSlides.slice(1, -1).forEach((slide, index) => {
      this.tl
        .fromTo(
          slide,
          {
            opacity: 0,
            display: "none",
          },
          {
            opacity: 1,
            display: "flex",
            duration: this.slideDuration,
            ease: "linear",
          },
          this.slideDuration * index
        )
        .to(
          slide,
          {
            opacity: 0,
            display: "none",
            duration: this.slideDuration,
            ease: "linear",
          },
          this.slideDuration * (index + 1)
        );
      this.tl
        .fromTo(
          slide.querySelector(".slide-count"),
          {
            y: "100%",
          },
          {
            y: 0,
            duration: this.slideDuration,
            ease: "linear",
          },
          this.slideDuration * index
        )
        .to(
          slide.querySelector(".slide-count"),
          {
            y: "-100%",
            duration: this.slideDuration,
            ease: "linear",
          },
          this.slideDuration * (index + 1)
        );
      this.tl
        .fromTo(
          slide.querySelector(".slide-title"),
          {
            y: "100%",
          },
          {
            y: 0,
            duration: this.slideDuration,
            ease: "linear",
          },
          this.slideDuration * index
        )
        .to(
          slide.querySelector(".slide-title"),
          {
            y: "-100%",
            duration: this.slideDuration,
            ease: "linear",
          },
          this.slideDuration * (index + 1)
        );
    });
  }
};

Carousel.prototype.registerButtons = function () {
  const prevButton = this.root.querySelector(".prev-button");
  const nextButton = this.root.querySelector(".next-button");
  const tl = this.tl;
  const slideDuration = this.slideDuration;

  this.tl.fromTo(
    prevButton,
    {
      scale: 0.5,
      opacity: 0,
      display: "none",
    },
    {
      scale: 1,
      opacity: 1,
      display: "block",
      duration: this.slideDuration / 3,
      ease: "linear",
    },
    0
  );

  this.tl.fromTo(
    nextButton,
    {
      scale: 1,
      opacity: 1,
      display: "block",
    },
    {
      scale: 0.5,
      opacity: 0,
      display: "none",
      duration: this.slideDuration / 3,
      ease: "linear",
    },
    this.tl.duration() - this.slideDuration / 3
  );

  prevButton.addEventListener("click", goToPrev);
  this.root
    .querySelector(".prev-button-mobile")
    .addEventListener("click", goToPrev);

  nextButton.addEventListener("click", goToNext);
  this.root
    .querySelector(".next-button-mobile")
    .addEventListener("click", goToNext);

  function goToPrev() {
    // This calculation is for preventing click spamming on the prev button
    // Even if the user spams prev button carousel will animate to exact interval
    const prevTime =
      Math.round(tl.time() / slideDuration) * slideDuration - slideDuration;

    const tween = tl.tweenTo(prevTime, { ease: "linear" });
    tween.restart();
  }

  function goToNext() {
    // This calculation is for preventing click spamming on the next button
    // Even if the user spams next button carousel will animate to exact interval
    const nextTime =
      Math.round(tl.time() / slideDuration) * slideDuration + slideDuration;

    const tween = tl.tweenTo(nextTime, { ease: "linear" });
    tween.restart();
  }
};

Carousel.prototype.registerSlider = function () {
  const sliderInner = this.root.querySelector(".slider-inner");
  const duration = this.tl.duration();
  const slidesCount = this.slidesCount;

  this.tl.fromTo(
    sliderInner,
    {
      width: 100 / slidesCount + "%",
    },
    {
      width: "100%",
      duration: duration,
      ease: "linear",
    },
    0
  );
};

Carousel.prototype.registerDrag = function () {
  let x = 0;

  const track = this.root.querySelector(".track");
  const backSlidesWrapper = this.root.querySelector(".back-slides-wrapper");
  const slidesWidth = this.slidesWidth;
  const singleSlideWidth = this.singleSlideWidth;
  const tl = this.tl;
  const totalTimelineWidth = slidesWidth - singleSlideWidth;
  const slideDuration = this.slideDuration;
  let translateX = 0;
  let toProgress = 0;

  const mouseDownHandler = function (e) {
    const clientX = e.clientX !== undefined ? e.clientX : e.touches[0].clientX;
    x = clientX;
    translateX = getTranslateX(backSlidesWrapper);

    toProgress = gsap.utils.mapRange(
      0,
      totalTimelineWidth,
      0,
      1,
      gsap.utils.clamp(0, totalTimelineWidth, -translateX)
    );

    document.addEventListener("mousemove", mouseMoveHandler);
    document.addEventListener("mouseup", mouseUpHandler);

    document.addEventListener("touchmove", mouseMoveHandler);
    document.addEventListener("touchend", mouseUpHandler);

    gsap.ticker.add(dragTicker);
  };

  const mouseMoveHandler = function (e) {
    const clientX = e.clientX !== undefined ? e.clientX : e.touches[0].clientX;
    const dx = clientX - x;
    toProgress = gsap.utils.mapRange(
      0,
      totalTimelineWidth,
      0,
      1,
      gsap.utils.clamp(0, totalTimelineWidth, -(translateX + dx))
    );
  };

  const mouseUpHandler = function (e) {
    gsap.ticker.remove(dragTicker);
    translateX = getTranslateX(backSlidesWrapper);
    const nextIndex = Math.round(Math.abs(translateX) / singleSlideWidth);

    const tween = tl.tweenTo(nextIndex * slideDuration, { ease: "linear" });
    tween.restart();

    document.removeEventListener("mousemove", mouseMoveHandler);
    document.removeEventListener("mouseup", mouseUpHandler);

    document.removeEventListener("touchmove", mouseMoveHandler);
    document.removeEventListener("touchend", mouseUpHandler);
  };

  function dragTicker() {
    tl.totalProgress(toProgress);
  }

  track.addEventListener("mousedown", mouseDownHandler);
  track.addEventListener("touchstart", mouseDownHandler);
};
